
const endpoints = {
  courseUrl:"https://www.khanglobalstudies.com/api/all-courses",
  adminBaseUrl: "https://admin2.khanglobalstudies.com/studio/",
  adminBaseURL2:  "https://admin.khanglobalstudies.com/studio/",
  // loginUrl: "https://admin2.khanglobalstudies.com/studio/login",
  get loginUrl() {
    return this.adminBaseUrl + "login";
  },
  playerUrl:"https://khanglobalstudies.com/",
  studioApi:"https://api.khanglobalstudies.com/v1/studio/",
  playerUrlNew:'https://web.kgs.ink/',
  recordServer:"https://studio-api.kgs.live/",
  broadcastUrl:"rtmp://broadcast.kgs.live/live",
  rtmpURl:"https://stream.kgs.live",
  apiBaseURL :"https://api.khanglobalstudies.com/studio/",
  videoAuth:true
};

export default endpoints
